<template>
<v-list-tile two-line v-if="isEditable && delayAvailable" @click="delay">
	<v-list-tile-action>
		<v-icon small>fa-clock</v-icon>
	</v-list-tile-action>
	<v-list-tile-content>
		<v-list-tile-title small>Delay</v-list-tile-title>
		<v-list-tile-sub-title small>Change the departure and/or arrival times</v-list-tile-sub-title>
	</v-list-tile-content>
</v-list-tile>
</template>

<script>
import Vuex from 'vuex'

export default {
	name: "JmRowActionDelay",

	props: {
		row: Object
	},

	computed: {
		...Vuex.mapState({ user: (state) => state.user.user }),

		isEditable () {
			return this.row.entity.isEditableBy(this.user);
		},

		delayAvailable () {
			return (this.row.entity.departure() && !this.row.entity.data.atd) ||
				(this.row.entity.arrival() && !this.row.entity.data.ata);
		}

	},

	methods: {
		delay () {
			// TODO
			console.log("DELAY ACTION HANDLER");
		}
	}
};

</script>

<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// src/components/widgets/RowActionWidgets/RowActionDelay.vue